import { render } from "./ShaIntegration.vue?vue&type=template&id=bfa2392e&scoped=true"
import script from "./ShaIntegration.vue?vue&type=script&lang=js"
export * from "./ShaIntegration.vue?vue&type=script&lang=js"

import "./ShaIntegration.vue?vue&type=style&index=0&id=bfa2392e&lang=css"
import "./ShaIntegration.vue?vue&type=style&index=1&id=bfa2392e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa2392e"]])

export default __exports__